import { Link } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import { Cookie, Settings2 } from 'lucide-react'
import { useCookieConsentContext } from '@/context/CookieConsentContext'
import { CookieButton } from './shared'

const CookieBanner = () => {
  const { showBanner, acceptAll, rejectOptional, openPreferences } = useCookieConsentContext()

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.aside
          role="dialog"
          aria-labelledby="cookie-banner-title"
          aria-describedby="cookie-banner-description"
          aria-live="polite"
          initial={{ opacity: 0, y: 48 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 48 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6 sm:pb-6"
        >
          <div
            className="mx-auto max-w-6xl rounded-[20px] p-5 shadow-[var(--sp-panel-shadow)] backdrop-blur-[18px] sm:p-6 lg:p-7"
            style={{
              background: 'var(--sp-nav)',
              border: '1px solid var(--sp-border-2)',
            }}
          >
            <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between lg:gap-8">
              <div className="flex flex-1 items-start gap-4">
                <div
                  className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[14px]"
                  style={{
                    background: 'var(--sp-chip)',
                    border: '1px solid var(--sp-border)',
                  }}
                  aria-hidden="true"
                >
                  <Cookie className="h-6 w-6" style={{ color: 'var(--sp-blue)' }} />
                </div>

                <div className="min-w-0">
                  <h2
                    id="cookie-banner-title"
                    className="font-display text-lg font-bold tracking-tight sm:text-xl"
                    style={{ color: 'var(--sp-text)' }}
                  >
                    Sua privacidade importa
                  </h2>
                  <p
                    id="cookie-banner-description"
                    className="mt-2 text-[14px] leading-relaxed sm:text-[15px]"
                    style={{ color: 'var(--sp-muted)' }}
                  >
                    Utilizamos cookies para garantir o funcionamento do site, analisar desempenho e
                    personalizar sua experiência. Você pode aceitar todos, rejeitar os opcionais ou
                    personalizar suas preferências conforme a LGPD.
                  </p>
                  <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-[13px]">
                    <Link
                      to="/privacidade"
                      className="font-medium underline-offset-2 transition-colors hover:underline"
                      style={{ color: 'var(--sp-blue)' }}
                    >
                      Política de Privacidade
                    </Link>
                    <span className="hidden sm:inline" style={{ color: 'var(--sp-border)' }}>
                      •
                    </span>
                    <button
                      type="button"
                      onClick={openPreferences}
                      className="inline-flex items-center gap-1.5 font-medium underline-offset-2 transition-colors hover:underline"
                      style={{ color: 'var(--sp-blue)' }}
                    >
                      <Settings2 className="h-3.5 w-3.5" aria-hidden="true" />
                      Personalizar preferências
                    </button>
                  </div>
                </div>
              </div>

              <div className="flex w-full flex-col gap-2.5 sm:flex-row sm:flex-wrap lg:w-auto lg:shrink-0 lg:flex-nowrap">
                <CookieButton
                  variant="ghost"
                  onClick={rejectOptional}
                  className="w-full sm:w-auto"
                >
                  Rejeitar opcionais
                </CookieButton>
                <CookieButton
                  variant="secondary"
                  onClick={openPreferences}
                  className="w-full sm:w-auto"
                >
                  Personalizar
                </CookieButton>
                <CookieButton variant="primary" onClick={acceptAll} className="w-full sm:w-auto">
                  Aceitar todos
                </CookieButton>
              </div>
            </div>
          </div>
        </motion.aside>
      )}
    </AnimatePresence>
  )
}

export default CookieBanner
